const EDepartment = {
  OBSTETRIC: 1,
  PEDIATRIC: 2,
};

export { EDepartment };
